import { Injectable } from '@angular/core';
import { UrlTree, Router ,   ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { KeycloakAuthGuard, KeycloakService } from 'keycloak-angular';
import { AppConfig } from '../lib/config/app-config';

const APPLICATION_REQUESTER_USER = 'ApplicationRequesterUser';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard extends KeycloakAuthGuard {
  initialized: boolean = false;

  constructor(
    protected readonly router: Router,
    protected readonly appConfig: AppConfig,
    protected readonly keycloak: KeycloakService
  ) {
    super(router, keycloak);
  }

  async initKeycloak(): Promise<void> {
    // Temporary solution to fix Keycloak authentication on test and acceptance.
    const { hostname } = window.location;
    var keycloakUrl = this.appConfig.getKeycloakUrl();
    if (hostname.startsWith('test0') || hostname.startsWith('acceptatie0')) {
      keycloakUrl = `${window.location.protocol}//${window.location.hostname}/auth`;
    }

    return await this.keycloak.init({
      config: {
        url: keycloakUrl,
        realm: this.appConfig.getKeycloakRealm(),
        clientId: this.appConfig.getKeycloakClientId(),
      },
      initOptions: {
        onLoad: 'check-sso',
        checkLoginIframe: false,
        silentCheckSsoRedirectUri: `${window.location.origin}/applicationrequester/frontend/assets/silent-check-sso.html`,
        responseMode: 'query',
      },
      enableBearerInterceptor: true,
      bearerPrefix: 'Bearer',
      /* The list of endpoints without keycloak */
      bearerExcludedUrls: [],
    }).then((authenticated) => {
      this.initialized = true;
    });
  }

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    if (!this.initialized) {
      await this.initKeycloak();
    }
    return await super.canActivate(route, state);
  }

  async isAccessAllowed(): Promise<boolean | UrlTree> {
    if (!this.authenticated) {
      await this.keycloak.login();
    }
    return this.roles.includes(APPLICATION_REQUESTER_USER);
  }
}
